import { useCallback } from 'react';

import { type UseV2FTMigrationModalFooterProps } from '../../models';
import { useV2FTMigrationAnalytics } from '../useV2FTMigrationAnalytics';

export const useV2FTMigrationModalFooter = ({ changeScreen, tokens }: UseV2FTMigrationModalFooterProps) => {
	const { triggerFAQFTMigrationEvent, triggerUpgradeFTMigrationEvent } = useV2FTMigrationAnalytics({
		tokens
	});

	const openFAQScreen = useCallback(() => {
		changeScreen('FAQ');
		triggerFAQFTMigrationEvent();
	}, [changeScreen, triggerFAQFTMigrationEvent]);

	const openUpgradeScreen = useCallback(() => {
		changeScreen('UPGRADE');
		triggerUpgradeFTMigrationEvent();
	}, [changeScreen, triggerUpgradeFTMigrationEvent]);

	return {
		openFAQScreen,
		openUpgradeScreen
	};
};
